"use client";

import { useState } from "react";
import Link from "next/link";
import Logo from "@/components/Logo";

function UserAvatar({ email, avatarUrl }: { email: string; avatarUrl?: string }) {
  if (avatarUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={avatarUrl}
        alt={email}
        width={34}
        height={34}
        style={{ width: 34, height: 34, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
      />
    );
  }
  return (
    <div style={{
      width: 34, height: 34, borderRadius: "50%",
      background: "var(--green)", color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 13, fontWeight: 800, flexShrink: 0, letterSpacing: 0,
    }}>
      {email[0].toUpperCase()}
    </div>
  );
}

export default function LandingNav({ userEmail, userAvatar }: { userEmail?: string; userAvatar?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="lp-nav-wrap">
      <div className="container">
        <nav className="lp-nav">
          <Logo />

          {/* Desktop links */}
          <div className="nav-links nav-links-desktop lp-nav-links">
            <a className="lp-nl" href="#radar">Radar</a>
            <a className="lp-nl" href="#how">How it works</a>
            <a className="lp-nl" href="#collection">Collection</a>
            <a className="lp-nl" href="#share">Share card</a>

            {userEmail ? (
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: 8 }}>
                <UserAvatar email={userEmail} avatarUrl={userAvatar} />
                <Link className="btn btn-primary" href="/radar" style={{ display: "flex", alignItems: "center", gap: 7 }}>
                  <svg width="13" height="13" viewBox="0 0 22 22" fill="none" style={{ flexShrink: 0 }}>
                    <circle cx="11" cy="11" r="9" stroke="currentColor" strokeWidth="1.8"/>
                    <circle cx="11" cy="11" r="5" stroke="currentColor" strokeWidth="1.8"/>
                    <circle cx="11" cy="11" r="2" fill="currentColor"/>
                  </svg>
                  Open app
                </Link>
              </div>
            ) : (
              <Link className="btn btn-primary" href="/login" style={{ marginLeft: 8 }}>
                Sign in
              </Link>
            )}
          </div>

          {/* Hamburger */}
          <button className="nav-burger" onClick={() => setOpen(!open)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </nav>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="nav-mobile">
          <a href="#radar"      onClick={() => setOpen(false)}>Radar</a>
          <a href="#how"        onClick={() => setOpen(false)}>How it works</a>
          <a href="#collection" onClick={() => setOpen(false)}>Collection</a>
          <a href="#share"      onClick={() => setOpen(false)}>Share card</a>
          {userEmail ? (
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 12px", marginTop: 4 }}>
              <UserAvatar email={userEmail} avatarUrl={userAvatar} />
              <div style={{ fontSize: 13, color: "var(--ink-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {userEmail}
              </div>
            </div>
          ) : null}
          {userEmail
            ? <Link href="/radar"  className="btn btn-primary" style={{ marginTop: 6 }} onClick={() => setOpen(false)}>Open app</Link>
            : <Link href="/login"  className="btn btn-primary" style={{ marginTop: 6 }} onClick={() => setOpen(false)}>Sign in</Link>
          }
        </div>
      )}
    </div>
  );
}
